export const META_FETCHED="META_FETCHED";

export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";

export const ENTITIES_FETCHED="ENTITY_FETCHED";
export const ENTITY_MODIFIED="ENTITY_MODIFIED";
export const ENTITY_CREATED="ENTITY_CREATED";



// WEBPACK FOOTER //
// ./src/actions/types.js